<template>
<div>
  <div id="page">
    <div class="row topCardGrid">
        <sp-card stripe="" :valor="cardData.itens.fila_espera" :descricao="$t('graficosSaude.filas.cards.fila')" :footerText="dataRef"/>
        <sp-card stripe="" :valor="cardData.itens.fluxo_entrada" :descricao="$t('graficosSaude.filas.cards.fluxo', {mes : cardData.dataRef})" :footerText="dataRef"/>
        <sp-card stripe="" :valor="cardData.itens.oferta" :descricao="$t('graficosSaude.filas.cards.oferta')" :footerText="dataRef"/>
    </div>
    <div class="flex row">
        <div class="flex sm12">
          <sp-360-panel :title="$t('graficosSaude.filas.filaCirurgia.painel.filaEspecialidade')" footerText=" ">
            <!-- <sp-360-chart id="filaProcedimento" type="vertical-bar" :data="filaProcedimento.chartData" :options="filaProcedimento.options" class='toprow'/> -->
            <sp-360-chart id="filaEspeciadade" type="horizontal-bar" :data="filaEspeciadade.chartData" :options="filaEspeciadade.options" class='chartPanel'/>
            <div slot="footerActions">
                <va-button v-show="showbuttom1()" color="danger" class="pull-right"  @click="openModalLista1($event)">
                  {{$t('graficosSaude.filas.detalhes.botao')}}
                </va-button>
            </div>
          </sp-360-panel>
        </div>
        <div class="flex   sm12">
          <sp-360-panel :title="$t('graficosSaude.filas.filaCirurgia.painel.fluxoEspecialidade')" footerText=" ">
            <!-- <sp-360-chart id="fluxoProcedimento" type="vertical-bar" :data="fluxoProcedimento.chartData" :options="fluxoProcedimento.options" class='toprow'/> -->
            <sp-360-chart id="fluxoEspeciadade" type="horizontal-bar" :data="fluxoEspeciadade.chartData" :options="fluxoEspeciadade.options" class='chartPanel'/>
              <div slot="footerActions">
                  <va-button v-show="showbuttom1()" color="danger" class="pull-right"  @click="openModalLista1($event)">
                    {{$t('graficosSaude.filas.detalhes.botao')}}
                  </va-button>
              </div>
          </sp-360-panel>
        </div>
        <div class="flex   sm12">
          <sp-360-panel :title="$t('graficosSaude.filas.filaCirurgia.painel.ofertaEspecialidade')" footerText=" ">
            <!-- <sp-360-chart id="ofertaProcedimento" type="vertical-bar" :data="ofertaProcedimento.chartData" :options="ofertaProcedimento.options" class='toprow'/> -->
            <sp-360-chart id="ofertaEspeciadade" type="horizontal-bar" :data="ofertaEspeciadade.chartData" :options="ofertaEspeciadade.options" class='chartPanel'/>
            <div slot="footerActions">
                <va-button v-show="showbuttom1()" color="danger" class="pull-right"  @click="openModalLista1($event)">
                  {{$t('graficosSaude.filas.detalhes.botao')}}
                </va-button>
            </div>
          </sp-360-panel>
        </div>
        <div class="flex sm12">
          <sp-360-panel :title="$t('graficosSaude.filas.filaCirurgia.painel.demandaOferta')" footerText=" " :tooltipOptions="tooltipOptions">
            <sp-360-chart id="filaEspeciadade" type="vertical-bar"  :data="multiDataset.chartData" :options="multiDataset.options" class='stackedChart'/>
            <!-- <sp-360-chart id="crescimentofilaChart" type="vertical-bar"  :data="crescimento.chartData" :options="crescimento.options" class='crescimentofilachart'/> -->
          </sp-360-panel>
        </div>
    </div>
  </div>
  <div id="modals">
    <va-modal show.sync="true" ref="modalLista1" :okText="$t('modal.close')" :okClass="'btn btn-primary btn-sm'"
      size="large" maxWidth="100em" fixedLayout=true v-model="showModalLista1" :title="$t('graficosSaude.filas.filaCirurgia.painel.filaEspecialidade')" :cancelText="''">
      <template slot="default">
        <sp360-data-table id="tabelaEstoqueMedicamentos" ref="tabelaEstoqueMedicamentos" :data="listaTabela1"
          :fields="camposTabelaLista1" :perPage="itemsPerPage" :onEachSide="onEachSide"
            />
      </template>
    </va-modal>
  </div>
</div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MethGlob from '@/utils/MetodosGlobais'
import SpCard from '@/components/ui/cards/SP360Card'
import Multiselect from 'vue-multiselect'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'

export default {
  name: 'fila-consultas',
  mixins: [],
  components: { SpCard, Sp360Chart, Sp360Panel, Multiselect, Sp360DataTable },

  data () {
    return {
      tooltipOptions: {
        content: 'Crescimento da fila = Fluxo de entrada subtraido da Oferta, dividido pela Fila de Espera',
        placement: 'top',
      },
      cardData: {
        itens: { fila_espera: 0, fluxo_entrada: 0, oferta: 0 },
        dataRef: '',
      },
      filaProcedimento: {
        chartData: {},
        options: {},
      },
      ofertaProcedimento: {
        chartData: {},
        options: {},
      },
      fluxoProcedimento: {
        chartData: {},
        options: {},
      },
      filaEspeciadade: {
        chartData: {},
        options: {},
      },
      fluxoEspeciadade: {
        chartData: {},
        options: {},
      },
      ofertaEspeciadade: {
        chartData: {},
        options: {},
      },
      multiDataset: {
        chartData: {},
        options: {},
      },
      crescimento: {
        chartData: {},
        options: {},
      },

      onEachSide: 1,
      showModalLista1: false,
      itemsPerPage: Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.TAMANHO_TABELAS,
      camposTabelaLista1: [
      ],
      sortFunctionsCamposTabelaLista1: {
      },
    }
  },

  created () {
    Promise.all([
      this.$store.dispatch('saude/filaDeProcedimentoConsolidadoPorClasse', { classeProcedimento: 'CIRURGIA' }),
      this.$store.dispatch('saude/filaDeProcedimentoPorProcedimento', { classeProcedimento: 'CIRURGIA' }),
      this.$store.dispatch('saude/filaDeProcedimentoPorGrupoDeProcedimentos', { classeProcedimento: 'CIRURGIA' }),
      this.$store.dispatch('saude/filaDeProcedimentoDetalhadoPorClasseDeProcedimento', { classeProcedimento: 'CIRURGIA' }),
      this.$store.dispatch('saude/filaDeProcedimentoDetalhado', { classeProcedimento: 'CIRURGIA' }),
      this.$store.dispatch('saude/filaDeProcedimentoPorEspecialidade', { classeProcedimento: 'CIRURGIA' }),
    ]).then((respostas) => {
      this.dataRef = this.$t('rodape.fonteData', { fonte: respostas[0].data.sigla_orgao + '/' + respostas[0].data.fonte, data: MethGlob.formataDataParaStringDataLocal(new Date(respostas[0].data.data_referencia_dado)) })
      this.cardData = this.popularCards(respostas[0].data)

      let corA = CorUtils.getCorPorNomeSp360('azul-columbia-claro')
      let corB = CorUtils.getCorPorNomeSp360('amarelo-pera-claro')
      let corC = CorUtils.getCorPorNomeSp360('vermelho-claro')

      let procedimentos = this.$t('graficosSaude.filas.filaConsulta.painel.procedimento')
      let pessoasNaFila = this.$t('graficosSaude.filas.filaConsulta.painel.pessoasNaFila')
      let fluxoEntrada = this.$t('graficosSaude.filas.filaConsulta.painel.fluxoEntrada')
      let oferta = this.$t('graficosSaude.filas.filaConsulta.painel.oferta')

      // BottomPanels
      this.popularGraficoDeLinha(this.filaEspeciadade, this.agruparDados(_.orderBy(respostas[2].data.data, 'fila_espera', 'desc')), 'fila_espera', 'grupo_procedimento', corA)
      this.filaEspeciadade.options = this.getchartOptions(pessoasNaFila, procedimentos, 'titulo', true)

      this.popularGraficoDeLinha(this.fluxoEspeciadade, this.agruparDados(_.orderBy(respostas[2].data.data, 'fluxo_entrada', 'desc')), 'fluxo_entrada', 'grupo_procedimento', corB)
      this.fluxoEspeciadade.options = this.getchartOptions(fluxoEntrada, procedimentos, 'titulo', true)

      this.popularGraficoDeLinha(this.ofertaEspeciadade, this.agruparDados(_.orderBy(respostas[2].data.data, 'oferta', 'desc')), 'oferta', 'grupo_procedimento', corC)
      this.ofertaEspeciadade.options = this.getchartOptions(oferta, procedimentos, 'titulo', true)

      this.popularTabelaModal(respostas[3].data.data)
      this.multiDataset.chartData = this.multiDataSet(respostas[2].data.data, ['fila_espera', 'fluxo_entrada', 'oferta'], 'grupo_procedimento', [corA, corB, corC])    
      this.multiDataset.options = this.getMultiOptions(oferta, procedimentos, 'titulo', true)
      this.crescimento.chartData = this.crescimentoDataset(respostas[2].data.data, ['fila_espera', 'fluxo_entrada', 'oferta'], 'grupo_procedimento', [corA, corB, corC])
      this.crescimento.options = this.crescimentoOptions(oferta, procedimentos, 'titulo', true)
    })
  },
  methods: {
    agruparDados (dados) {
      let clone = _.cloneDeep(dados)
      let top10 = clone.splice(0, 10)
      let reduced = _.reduceRight(clone, (acc, e) => {
        acc.grupo_procedimento = 'Outros'
        acc.procedimento += e.procedimento
        acc.especialidade += e.especialidade
        acc.fila_espera += e.fila_espera
        acc.fluxo_entrada += e.fluxo_entrada
        acc.oferta += e.oferta
        return acc
      }, {
        grupo_procedimento: 'Outros',
        procedimento: 'Outros',
        especialidade: 0,
        fila_espera: 0,
        fluxo_entrada: 0,
        oferta: 0,
        classe_procedimento: 'CIRURGIA',
      })
      top10.push(reduced)
      return top10
    },

    popularCards (data) {
      return {
        itens: _.find(data.data, (e) => { return e.classe_procedimento === 'CIRURGIA' }),
        dataRef: data.data[0].mes_entrada + '/' + new Date(data.data_referencia_dado).getFullYear()
      }
    },

    popularGraficoDeLinha (chartObject, data, prop, labelProp, colorSet, wordwrap = false) {
      let dados = data
      let Labels = []

      let dataSet = {
        label: '',
        backgroundColor: colorSet,
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        categoryPercentage: 0.4,
        barPercentage: 1,

        // yAxisID: 'y-axis-1',
      }

      dados.forEach((el) => {
        if (el[prop]) {
          dataSet.label = el[labelProp]
          dataSet.data.push(el[prop])
          if (wordwrap) {
            let entry = el[labelProp].split(' ')
            Labels.push(entry)
          } else {
            Labels.push(el[labelProp])
          }
        }
      })

      let datasets = []
      datasets.push(dataSet)
      chartObject.chartData = { datasets: datasets, labels: Labels }
    },

    filaProcedimentoChartOptions (xAxixLabel, yAxixLabel, titulo) {
      return {
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: false,
          position: 'nearest',
          callbacks: {
            title: (tooltipItem, chart) => {
            },
            label: (tooltipItem, chart) => {
              let label = ''
              if (Array.isArray(tooltipItem.xLabel)) {
                label = tooltipItem.xLabel.join(' ') + '  ' || ''
              } else {
                label = tooltipItem.xLabel + '  ' || ''
              }
              label += MethGlob.formatarNumero(tooltipItem.yLabel)
              return label
            },
          },
        },
        maintainAspectRatio: false,
        aspectRatio: 4,
        responsive: true,
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 0,
            bottom: 5,
          },
        },
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            fontColor: '#34495e',
            fontFamily: 'sans-serif',
            fontSize: 14,
            padding: 20,
            usePointStyle: true,
          },
        },
        scales: {
          xAxes: [{
            categoryPercentage: 0.4,
            display: true,
            type: 'category',
            distribution: 'series',
            ticks: {
              min: 0,
              // fontSize: 8,
              autoSkip: false,
            },
            scaleLabel: {
              display: false,
              labelString: this.$t(xAxixLabel || 'LegendaX'),
            },

          }],
          yAxes: [{
            gridLines: {
              display: false,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 8,
              callback: (value) => MethGlob.formatarNumero(value),
            },
            id: 'y-axis-1',
            type: 'logarithmic',
            position: 'left',
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(yAxixLabel || 'LegendaY'),
            },
          },
          // {
          //   id: 'y-axis-2',
          //   ticks: {
          //     min: 0, // minimum tick
          //     callback: (value) => value.toLocaleString('pt-BR'),
          //   },
          //   type: 'logarithmic',
          //   position: 'right',
          //   display: true,
          //   scaleLabel: {
          //     display: true,
          //     labelString: this.$t('assistencia.servicos.grafico.legendaX2'),
          //   },
          // }
          ],
        },
        plugins: {
          datalabels: {
            clamp: true,
            font: {
              size: 16,
              weight: 'bold',
            },
            anchor: 'start',
            align: 'end',
            color: '#000',
            // display: false,
          },
        },
      }
    },

    getchartOptions (xAxixLabel, yAxixLabel) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 0,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              return MethGlob.formatarNumero(value)
            },
            font: {
              weight: 'bold',
            },
          },
        },
        tooltips: {
          enabled: true,
          intersect: true,
          callbacks: {
            title: (tooltipItem, chart) => {
            },
            label: (tooltipItem, chart) => {
              let label = ''
              if (Array.isArray(tooltipItem.xLabel)) {
                label = tooltipItem.yLabel.join(' ') + '  ' || ''
              } else {
                label = tooltipItem.yLabel + '  ' || ''
              }
              label += MethGlob.formatarNumero(tooltipItem.xLabel)
              return label
            },
          },
        },
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            categoryPercentage: 0.2,
            scaleLabel: {
              display: false,
              labelString: yAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
            },
          }],
          xAxes: [{
            id: 'BarAxis',
            position: 'left',
            gridLines: {
              display: false,
            },
            type: 'logarithmic',
            scaleLabel: {
              display: true,
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 10,
              callback: function (value, index, values) {
                return MethGlob.formatarGrandesNumeros(value)
              },
            },
          },
          ] },
      }
    },

    popularTabelaModal (data) {
      this.listaTabela1 = _.orderBy(data, 'procedimento')
      this.camposTabelaLista1 = [
        // {
        //   name: 'classe_procedimento',
        //   sortField: 'classe_procedimento',
        //   title: this.$t('graficosSaude.filas.detalhes.campos.classe_procedimento'),
        //   width: '54%',
        // },
        {
          name: 'procedimento',
          sortField: 'procedimento',
          title: this.$t('graficosSaude.filas.detalhes.campos.procedimento'),
          width: '30%',
        },
        {
          name: 'especialidade',
          sortField: 'especialidade',
          title: this.$t('graficosSaude.filas.detalhes.campos.especialidade'),
          width: '30%',
        }, {
          name: 'fila_espera',
          sortField: 'fila_espera',
          title: this.$t('graficosSaude.filas.detalhes.campos.fila_espera'),
          callback: MethGlob.thousandSeparator,
          width: '20%',
        }, {
          name: 'fluxo_entrada',
          sortField: 'fluxo_entrada',
          title: this.$t('graficosSaude.filas.detalhes.campos.fluxo_entrada'),
          callback: MethGlob.thousandSeparator,
          width: '20%',
        }, {
          name: 'oferta',
          sortField: 'oferta',
          title: this.$t('graficosSaude.filas.detalhes.campos.oferta'),
          callback: MethGlob.thousandSeparator,
          width: '20%',
        }]
      this.sortFunctionsCamposTabelaLista1 = {
        'classe_procedimento': MethGlob.ordenaTabela,
        'especialidade': MethGlob.ordenaTabela,
        'procedimento': MethGlob.ordenaTabela,
        'fila_espera': MethGlob.ordenaTabelaParseInt,
        'fluxo_entrada': MethGlob.ordenaTabelaParseInt,
        'oferta': MethGlob.ordenaTabelaParseInt,
      }
    },

    openModalLista1 () { this.showModalLista1 = !this.showModalLista1 },

    showbuttom1 () {
      return true
    },

    multiDataSet (data, prop, labelProp, colorSet) {
      let Labels = []
      data = _.cloneDeep(_.orderBy(data, prop[0], 'desc'))
      let dataN = _.remove(data, (el) => {
        return (el[prop[0]] && el[prop[1]] && el[prop[2]])
      })

      let agregado = {}
      agregado[prop[0]] = 0
      agregado[prop[1]] = 0
      agregado[prop[2]] = 0
      data.forEach(el => {
        agregado[prop[0]] += el[prop[0]]
        agregado[prop[1]] += el[prop[1]]
        agregado[prop[2]] += el[prop[2]]
        agregado[labelProp] = 'Outros'
      })
      dataN.push(agregado)

      let datasets = []
      dataN = _.orderBy(dataN, prop[0], 'desc')
      dataN.forEach(el => {
        Labels.push(el[labelProp])
      })

      let order = 0
      dataN.forEach(el => {
        let fila = el[prop[0]]
        let entrada = el[prop[1]]
        let oferta = el[prop[2]]

        let fluxoOferta = 0
        el.percentualCrescimento = 0
        fluxoOferta = (entrada - oferta)
        el.percentualCrescimento = (fluxoOferta / fila) * 100

        // ['fila_espera', 'fluxo_entrada', 'oferta']
      })

      

      datasets.push(this.montarDataSet(dataN, 'percentualCrescimento', 'orange', order++, 'line', false)) // 2
      datasets.push(this.montarDataSet(dataN, prop[0], colorSet[0], order++, false, true)) // 0
      datasets.push(this.montarDataSet(dataN, prop[1], colorSet[1], order++, false, true)) // 1
      datasets.push(this.montarDataSet(dataN, prop[2], colorSet[2], order++, false, false)) // 2

      // ['fila_espera', 'fluxo_entrada', 'oferta']

      datasets[3].label = 'Oferta'
      datasets[2].label = 'Fluxo de entrada'
      datasets[1].label = 'Fila de espera'
      datasets[0].label = 'Crescimento da fila'
      datasets[0].pointStyle = 'triangle'
      datasets[0].rotation = (context) => {
        let index = context.dataIndex
        let val = context.dataset.data[index]
        if (val < 0) {
          return 180
        } else {
          return 0
        }
      }
      datasets[0].pointRadius = 10
      datasets[0].datalabels = { font: { size: 16, weight: 'bold' } }
      datasets[1].datalabels = { font: { size: 16, weight: 'bold' } }
      datasets[2].datalabels = { font: { size: 16, weight: 'bold' } }
      datasets[3].datalabels = { font: { size: 16, weight: 'bold' } }

      return { datasets: datasets, labels: Labels }
    },

    crescimentoDataset (data, prop, labelProp, colorSet) {
      let Labels = []

      data = _.cloneDeep(_.orderBy(data, prop[0], 'desc'))

      let dataN = _.remove(data, (el) => {
        return (el[prop[0]] && el[prop[1]] && el[prop[2]])
      })

      let agregado = {}
      agregado[prop[0]] = 0
      agregado[prop[1]] = 0
      agregado[prop[2]] = 0
      data.forEach(el => {
        agregado[prop[0]] += el[prop[0]]
        agregado[prop[1]] += el[prop[1]]
        agregado[prop[2]] += el[prop[2]]
        agregado[labelProp] = 'Outros'
      })
      dataN.push(agregado)

      let datasets = []
      dataN = _.orderBy(dataN, prop[0], 'desc')
      dataN.forEach(el => {
        Labels.push(el[labelProp])
      })

      let order = 0
      dataN.forEach(el => {
        let fila = el[prop[0]]
        let entrada = el[prop[1]]
        let oferta = el[prop[2]]

        let fluxoOferta = 0
        el.percentualCrescimento = 0
        fluxoOferta = (entrada - oferta)
        el.percentualCrescimento = (fluxoOferta / fila) * 100

        // ['fila_espera', 'fluxo_entrada', 'oferta']
      })

      datasets.push(this.montarDataSet(dataN, 'percentualCrescimento', 'orange', order++, 'line', false)) // 2

      // ['fila_espera', 'fluxo_entrada', 'oferta']

      datasets[0].label = 'Crescimento da fila'
      datasets[0].pointStyle = 'triangle'
      datasets[0].rotation = (context) => {
        let index = context.dataIndex
        let val = context.dataset.data[index]
        if (val < 0) {
          return 180
        } else {
          return 0
        }
      }
      datasets[0].pointRadius = 10
      datasets[0].datalabels = { font: { size: 16, weight: 'bold' } }

      return { datasets: datasets, labels: Labels }
    },

    montarDataSet (dados, prop, colorSet, order, type = false, stack = false) {
      let dataSet = {
        label: '',
        backgroundColor: colorSet,
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        order: order,
        datalabels: {},
        barPercentage: 1,
        categoryPercentage: 0.8,
      }

      if (type) {
        dataSet.type = type
        dataSet.fill = false
        dataSet.yAxisID = 'LineAxis'
        // dataSet.backgroundColor =
        dataSet.borderColor = this.$store.getters.palette.transparent
      }

      dados.forEach((el) => {
        dataSet.label = prop
        dataSet.data.push(el[prop])
      })

      return dataSet
    },

    getMultiOptions (xAxixLabel, yAxixLabel) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 0,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              if (context.datasetIndex === 0) {
                if (value < 0) {
                  return '-' + MethGlob.formatarNumero(value) + '%'
                } else if (value > 0) {
                  return '+' + MethGlob.formatarNumero(value) + '%'
                } else {
                  return MethGlob.formatarNumero(value) + '%'
                }
              } else {
                return MethGlob.formatarNumero(value)
              }
            },
            font: {
              weight: 'bold',
            },
          },
        },
        tooltips: {
          enabled: true,
          intersect: true,
          callbacks: {
            title: (tooltipItem, chart) => {
            },
            label: (tooltipItem, chart) => {
              let label = ''
              if (Array.isArray(tooltipItem.xLabel)) {
                label = chart.datasets[tooltipItem.datasetIndex].label.join(' ') + '  ' || ''
              } else {
                label = chart.datasets[tooltipItem.datasetIndex].label + '  ' || ''
              }
              label += MethGlob.formatarNumero(tooltipItem.value)
              return label
            },
          },
        },
        responsive: true,
        scales: {
          xAxes: [{
            categoryPercentage: 0.8,
            scaleLabel: {
              display: false,
              labelString: yAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
              // fontSize: 8,
            },
          }],
          yAxes: [{
            id: 'BarAxis',
            position: 'left',
            gridLines: {
              display: false,
            },
            type: 'logarithmic', // 'linear',
            scaleLabel: {
              display: true,
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 10,
              callback: function (value, index, values) {
                return MethGlob.formatarGrandesNumeros(value)
              },
            },
          }, {
            id: 'LineAxis',
            position: 'right',
            type: 'linear',
            gridLines: {
              display: false,
            },
            scaleLabel: {
              display: true,
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: false,
              autoSkip: true,
              maxTicksLimit: 10,
              callback: function (value, index, values) {
                return MethGlob.formatarGrandesNumeros(value) + '%'
              },
            },
          }],
        },
      }
    },
    crescimentoOptions (xAxixLabel, yAxixLabel) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 0,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              if (context.datasetIndex === 0) {
                if (value < 0) {
                  return '-' + MethGlob.formatarNumero(value) + '%'
                } else if (value > 0) {
                  return '+' + MethGlob.formatarNumero(value) + '%'
                } else {
                  return MethGlob.formatarNumero(value) + '%'
                }
              } else {
                return MethGlob.formatarNumero(value)
              }
            },
            font: {
              weight: 'bold',
            },
          },
        },
        tooltips: {
          enabled: true,
          intersect: true,
          callbacks: {
            title: (tooltipItem, chart) => {
            },
            label: (tooltipItem, chart) => {
              let label = ''
              if (Array.isArray(tooltipItem.xLabel)) {
                label = chart.datasets[tooltipItem.datasetIndex].label.join(' ') + '  ' || ''
              } else {
                label = chart.datasets[tooltipItem.datasetIndex].label + '  ' || ''
              }
              label += MethGlob.formatarNumero(tooltipItem.value)
              return label
            },
          },
        },
        responsive: true,
        scales: {
          xAxes: [{
            categoryPercentage: 0.8,
            scaleLabel: {
              display: false,
              labelString: yAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
              // fontSize: 8,
            },
          }],
          yAxes: [{
            id: 'LineAxis',
            position: 'left',
            type: 'linear',
            gridLines: {
              display: false,
            },
            scaleLabel: {
              display: true,
              labelString: xAxixLabel,
            },
            ticks: {
              display: false,
              beginAtZero: false,
              autoSkip: true,
              maxTicksLimit: 10,
              callback: function (value, index, values) {
                return MethGlob.formatarGrandesNumeros(value) + '%'
              },
            },
          }],
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped >
.chartPanel{
  max-height: 35rem;
}

.toprow{
  max-height: 40rem;
}

.brick{
  align-content: center;
  display: block;
  height: 110rem;
}

.column {
  float: left;
  width: 33.33%;
}
.stackedChart{
  max-height: 60rem;
}
#crescimentofilaChart{
  max-height: 20rem;
}

</style>
